import {Editor} from "../../../../../../pkg/slate.js";
export const isEnd = (editor, point, at) => !!point && Editor.isEnd(editor, point, at);
